export default {"src":"/_next/static/media/energyLogo2.28d94eb1.svg","height":74,"width":77,"blurWidth":0,"blurHeight":0};